import React, { useEffect, useState } from "react";
import Topbar from "../../Component/Topbar/Topbar";
import { Table } from "../../Component/Table/Table";
import DateRange from "../../Component/DateRange/DateRange";
import moment from "moment";
import { search, view } from "../../assets/img";
import useSearchFunction from "../../Component/searchFunction";
import { post } from "../redux/api/ApiHandler";
import { URLS } from "../redux/api/Constants";
import SelectBox1 from "../../Component/SelectBox1";
import { useNavigate } from "react-router-dom";

const Notification = () => {
  const [fromDates, setFromDates] = useState(null);
  const [toDates, setToDates] = useState(null);
  const [list, setList] = useState([]);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [status, setStatus] = useState(null);

  const debounceval = useSearchFunction(searchValue);

  let role = localStorage.getItem("role");
  console.log("role--->", role);
  const navigate = useNavigate();

  const handleNavigation = (data) => {
    console.log("navData", data);

    switch (data?.title) {
      case "New Ticket Created":
        navigate("/new-ticket-view", {
          state: {
            id: data?.ticket_id,
            type: "view",
          },
        });
        break;
      case "Technical Support Required":
        navigate("/pending-view", {
          state: {
            id: data?.ticket_id,
            type: "view",
          },
        });
        break;
      case "Senior Support Required":
        navigate("/pending-view", {
          state: {
            id: data?.ticket_id,
            type: "view",
          },
        });
        break;
      case "Inventory Support Required":
        navigate("/pending-view", {
          state: {
            id: data?.ticket_id,
            type: "view",
          },
        });
        break;
      case "Next Visit Support Required":
        navigate("/pending-view", {
          state: {
            id: data?.ticket_id,
            type: "view",
          },
        });
        break;

      case "Inventory Department is Assigned":
        navigate("/inventory-view", {
          state: {
            id: data?.ticket_id,
            type: "view",
          },
        });
        break;

      case "Inventory Dispatched":
        navigate(role == "Inventory" ? "/view-dispatch" : "/inventory-view", {
          state: {
            id: data?.ticket_id,
            type: "view",
            tickType: "Dispatch",
            detail: role,
          },
        });
        break;
      case "Inventory Delivered":
        navigate(role == "Inventory" ? "/delivery-view" : "/inventory-view", {
          state: {
            id: data?.ticket_id,
            type: "view",
            tickType: "Dispatch",
          },
        });
        break;
      case "Inventory Department Assigned":
        navigate(role == "Inventory" ? "/view-inventory" : "/inventory-view", {
          state: {
            id: data?.ticket_id,
            type: "view",
            tickType: "Yet",
          },
        });
        break;
      case "Technical Support Assigned":
        navigate("/technical-view", {
          state: {
            id: data?.ticket_id,
            type: "view",
          },
        });
        break;
      case "Technical Department Assigned":
        navigate(role == "Technical" ? "/view-inventory" : "/technical-view", {
          state: {
            id: data?.ticket_id,
            type: "view",
            tickType: "Yet",
          },
        });
        break;

      case "Senior Support Assigned":
        navigate("/service-view", {
          state: {
            id: data?.ticket_id,
            type: "view",
          },
        });
        break;

      case "Next Visit Assigned":
        navigate("/next-visit-view", {
          state: {
            id: data?.ticket_id,
            type: "view",
          },
        });
        break;

      case "Moved to Super Admin":
        navigate("/pending-view", {
          state: {
            id: data?.ticket_id,
            type: "view",
          },
        });
        break;

      case "Work Completed":
        navigate("/work-view", {
          state: {
            id: data?.ticket_id,
            type: "view",
          },
        });
        break;
      case "Ticket Closed":
        navigate("/closed-view", {
          state: {
            id: data?.ticket_id,
            type: "view",
          },
        });
        break;
      case "Activated":
      case "Deactivated":
      case "Account Deactivated":
        switch (data?.role) {
          case 1:
            navigate("/super-admin-add", {
              state: { type: "view", id: data?.user_id },
            });
            break;
          case 2:
            navigate("/inventory-add", {
              state: { type: "view", id: data?.user_id },
            });
            break;
          case 3:
            navigate("/technical-add", {
              state: { type: "view", id: data?.user_id },
            });
            break;
          case 4:
            navigate("/regional-add", {
              state: { type: "view", id: data?.user_id },
            });
            break;
          case 5:
            navigate("/service-add", {
              state: { type: "view", id: data?.user_id },
            });
            break;
          default:
            break;
        }
    }
  };

  // Active----Activated
  // Deactive-----Deactivated
  // New Ticket---New Ticket
  // Work Completed---Work Completed
  // Ticket Closed---Ticket Closed
  // Pending Inventory----Inventory Support Required
  // Pending Technical----Technical Support Required
  // Pending NextVisit----Next Visit Support Required
  // Pending SeniorSupport---Senior Support Required
  // Inventory Ticket Assigned--Inventory Department Assigned
  // Technical Ticket Assigned--Technical Department Assigned
  // NextVisit Ticket Assigned--Next Visit Assigned
  // SeniorSupport Ticket Assigned--Senior Support Assigned
  // Inventory-Dispatched--Inventory Dispatched
  // Inventory-Delivered--Inventory Delivered
  // Technical Issuse Resolved--Technical Issuse Resolved
  // Moved to Super Admin---Moved to Super Admin

  const statusOptions = [
    { value: "Activated", label: "Active" },
    { value: "Deactivated", label: "Deactivate" },
    { value: "New Ticket", label: "New Ticket" },
    { value: "Inventory Support Required", label: "Pending - Inventory" },
    { value: "Technical Support Required", label: "Pending - Technical" },
    { value: "Next Visit Support Required", label: "Pending - Nextvist" },
    { value: "Senior Support Required", label: "Pending - Seniorsupport" },
    { value: "Inventory Ticket Assigned", label: "Inventory Ticket Assigned" },
    { value: "Technical Ticket Assigned", label: "Technical Ticket Assigned" },
    { value: "Nextvist Ticket Assigned", label: "Nextvist Ticket Assigned" },
    {
      value: "SeniorSupport Ticket Assigned",
      label: "Seniorsupport Ticket Assigned",
    },
    { value: "Inventory Dispatched", label: "Inventory - Dispatched" },
    { value: "Inventory Delivered", label: "Inventory - Deliverd" },
    { value: "Technical Issuse Resolved", label: "Technical issue resolved" },
    { value: "Work Completed", label: "Work Completed" },
    { value: "Ticket Closed", label: "Ticket Closed" },
    { value: "Moved to Super Admin", label: "Moved to Super Admin" },
  ];

  const columns = React.useMemo(() => [
    {
      Header: "S.No",
      accessor: "page",
      Cell: ({ value, row }) => {
        return <p>{(value - 1) * 10 + row.index + 1}</p>;
      },
    },
    {
      Header: "Date and time",
      accessor: "created_at",
      Cell: ({ value, row }) => {
        return (
          <p className="text-nowrap ">
            {moment(value).format("DD-MM-YYYY , h:mm A")}
          </p>
        );
      },
    },

    {
      Header: "Scenerio",
      accessor: "title",
      Cell: ({ value, row }) => {
        return <p className="text-nowrap ">{value ?? "-"}</p>;
      },
    },
    {
      Header: "Description",
      accessor: "desc",
      Cell: ({ value, row }) => {
        return (
          <p className="text-wrap" style={{ width: "300px" }}>
            {value ?? "-"}
          </p>
        );
      },
    },
    {
      Header: "View",
      accessor: "",
      Cell: ({ value, row }) => {
        const canView =
          role === "Super Admin" ||
          (role === "Technical" &&
            row?.original?.title === "Technical Department Assigned") ||
          (role === "Inventory" &&
            row?.original?.title === "Inventory Department Assigned");

        return (
          <div className="d-flex ac-jc mt-2 gap-3">
            <button
              onClick={() => {
                if (!canView) return;
                handleNavigation(row?.original);
              }}
              className="cust-btn"
              disabled={!canView}
              style={{
                opacity: canView ? 1 : 0.4,
                cursor: canView ? "pointer" : "not-allowed",
              }}
            >
              <img src={view} alt="view" className="editor-btn" />
            </button>
          </div>
        );
      },
    },
  ]);

  const fetchNotification = async (
    page,
    search,
    fromDates,
    toDates,
    status,
  ) => {
    setFromDates(fromDates);
    setToDates(toDates);
    setStatus(status);
    let payload = {
      page: page,
      search: search,
      rows: 10,
      order: "desc",
      from_date: fromDates ? moment(fromDates).format("YYYY-MM-DD") : "",
      to_date: toDates ? moment(toDates).format("YYYY-MM-DD") : "",
      title: status?.value ?? "",
    };
    console.log("notificationPayload", payload);
    // return;
    let res = await post(URLS.NOTICATION, payload);
    console.log("Notires", res);
    if (res?.status == "success") {
      let obj = res?.notifications?.map((i) => {
        return {
          ...i,
          page: res?.pagination?.current_page,
        };
      });
      setList(obj);
      setPagination(res?.pagination);
    }
  };

  useEffect(() => {
    fetchNotification(page, debounceval, fromDates, toDates, status);
  }, [page, debounceval, fromDates, toDates, status]);

  return (
    <div>
      <Topbar header="Notification" />

      <div className=" w-100 d-flex ac-jb gap-3 mt-4 px-5">
        <h4 className="f2 fs-sm-14 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22">
          Total Notification : {pagination?.total}
        </h4>
        <DateRange
          fromDate={fromDates}
          setFromDate={(val) => {
            setPage(1);
            setFromDates(val);
            // fetchNotification(1, debounceval, val, toDates, status);
          }}
          toDate={toDates}
          setToDate={(val) => {
            setPage(1);
            setToDates(val);
            // fetchNotification(1, debounceval, fromDates, val, status);
          }}
        />

        <div className="search-input col-md-3 d-flex ac-jb ">
          <input
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            type="text"
            placeholder="Search "
            style={{ border: "none", width: "200px" }}
            className="search-field f1  fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17"
          />
          <img src={search} className="search" />
        </div>
      </div>
      <div className="container_fluit1 px-4 ">
        <div className="d-flex ac-je">
          {role == "Super Admin" && (
            <div className="col-md-4 mb-3">
              <SelectBox1
                placeholder={"Select Ticket Status"}
                options={statusOptions}
                selected={status}
                setSelected={(val) => {
                  setPage(1);
                  setStatus(val);
                  // fetchNotification(1, debounceval, fromDates, toDates, val);
                }}
              />
            </div>
          )}
        </div>
        <Table
          columns={columns}
          setPageno={setPage}
          pagecount={pagination}
          data={list ?? []}
          show={true}
        />
      </div>
    </div>
  );
};

export default Notification;
